import { logDog } from '@/shared/log';
import { isWechat } from '@/shared/browser';
let weChatAdIns = null;

const createWeChatAd = () => {
    if (weChatAdIns == null) {
        jm('#g_body').append(
            '<div class="popupWXQrCode" id="popupWXQrCode"></div>'
        );
        weChatAdIns = new Vue({
            el: '#popupWXQrCode',
            data() {
                return {
                    imgPath: `${window._resImageRoot}/image/wx/wxQrCodeBack.png`,
                    wxQrCodePath: `${window._resImageRoot}/image/mobiFooterWechatQrCode.gif`,
                    siteName: '免费建站',
                    touchStartTime: 0,
                };
            },
            methods: {
                close() {
                    jm('#popupWXQrCode').hide();
                },
                show() {
                    jm('#popupWXQrCode').show();
                },
                touchstart() {
                    this.touchStartTime = new Date().getTime();
                },
                touchend() {
                    let time = new Date().getTime();
                    let interval = time - this.touchStartTime;
                    if (interval > 500 && isWechat()) {
                        let DOG_ID_FREE_ADV = 200010;
                        let DOG_SRC_WECHAT_LONG_PRESS = 14;
                        logDog(DOG_ID_FREE_ADV, DOG_SRC_WECHAT_LONG_PRESS);
                    }
                },
            },
            template: `
      <div id='popupWXQrCode' class='popupWXQrCode'>
        <div class='wxQrBg J_close' @click="close"></div>
        <img :src="imgPath" class='J_bigPic bgPic' @touchstart="touchstart" @touchend="touchend">
        <div class='wxQrTip' v-text="siteName"></div>
        <img :src="wxQrCodePath" class='wxQrCodePic'>
      </div>
      `,
        });
    }
};

export const showWeChatAd = () => {
    createWeChatAd();
    weChatAdIns && weChatAdIns.show();
};

export const hideWeChatAd = () => {
    if (weChatAdIns) {
        weChatAdIns.hide();
    }
};
